__turbopack_context__.v({
  "container": "VBUzVW_container",
  "pushDown": "VBUzVW_pushDown",
  "pushLeftDisabled": "VBUzVW_pushLeftDisabled",
});
